// @flow
import { combineReducers } from 'redux';
import groups from './groups';
import idealistDayEvents from './idealistDayEvents';
import listings from './listings';
import search from './search';
import type { Action as GroupsAction } from '../../actions/groupDashboard/groups';
import type { Action as IdealistDayEventsAction } from '../../actions/groupDashboard/idealistDayEvents';
import type { Action as ListingsAction } from '../../actions/groupDashboard/listings';
import type { Action as SearchAction } from '../../actions/groupDashboard/search';

export default combineReducers<
  {
    groups: typeof groups,
    idealistDayEvents: typeof idealistDayEvents,
    listings: typeof listings,
    search: typeof search
  },
  GroupsAction | IdealistDayEventsAction | ListingsAction | SearchAction
>({ groups, idealistDayEvents, listings, search });
